/* @flow */
/* eslint-disable babel/no-invalid-this */
import MediaType from "nexia_mobile/framework/media_type";
import type { UnenrollFeature } from "./types";

export default function Unenroll(feature: UnenrollFeature) {
  let unenrollAction = feature.actions.unenroll;

  this.hasGuidedUnenrollment = () => unenrollAction.type === MediaType.SCHEMA;

  this.unenroll = () => {
    if (unenrollAction == null) {
      return $.Deferred.reject(
        new Error(
          "Attempted to unenroll device whose unenroll feature has no unenroll action"
        )
      );
    }
    return this.executeDeviceAction(
      unenrollAction,
      {},
      { updateModelWithResponse: false }
    );
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/unenroll.js